import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import team3 from '../../assets/img/team/avatar.png';
import Avatar from '../common/Avatar';
import * as icon from 'react-bootstrap-icons';

const ProfileDropdown = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(prevState => !prevState);

  const profileUserName = () => {
    const { otherInfo } = props;
    const { firstName, lastName } = otherInfo;
    let userName = '';
    if ((firstName || '').length > 0 && (lastName || '').length > 0) {
      userName = firstName + ' ' + lastName;
    } else if ((firstName || '').length > 0) {
      userName = firstName;
    } else if ((lastName || '').length > 0) {
      userName = lastName;
    }
    return <span style={{
      marginLeft: '5px',
      fontSize: '12px',
      whiteSpace: 'nowrap',
      width: '100px',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }}>{`${userName}`}</span>
  }
  return (
    <Dropdown
      nav
      inNavbar
      isOpen={dropdownOpen}
      toggle={toggle}
      onMouseOver={() => {
        let windowWidth = window.innerWidth;
        windowWidth > 992 && setDropdownOpen(true);
      }}
      onMouseLeave={() => {
        let windowWidth = window.innerWidth;
        windowWidth > 992 && setDropdownOpen(false);
      }}
    >
      <DropdownToggle nav className="pr-0 d-flex align-items-center">
        <Avatar src={team3} />{profileUserName()}
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-card">
        <div className="bg-white rounded-soft py-2">
          {/*  <DropdownItem tag={Link} to="/pages/profile">
            Profile
          </DropdownItem> 
          <DropdownItem divider />*/}
          <DropdownItem tag={Link} onClick={() => { props.onProfileItemClcik('LOGOUT') }} >
            <icon.BoxArrowRight className='fs-2' /> Logout
          </DropdownItem>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;
